import React, { Fragment, Suspense } from "react";
import { FaRupeeSign } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useDetailPageDetails } from "../../Pregrine/DetailPageDetails/useDetailPageDetails";
import { ProductOptionsShimmer } from "../ProductOptions";
import Options from "../ProductOptions/options";
import ProductQuantity from "../ProductQuantity/ProductQuantity";
import GetWishlist from "../Wishlist/GetWishlist";
import classes from "./DetailPageDetails.module.css";

const DetailPagePincodeCheck = React.lazy(() =>
  import("../DetailPagePincodeCheck")
);

import classNames from "classnames";
import ShareButton from "../../components/ShareButton/ShareButton";
import { formatIndianNumber } from "../../utility/formatPrice";
import DetailPageCouponModal from "../DetailPageCouponModal";
const EnquiryFormDetailPage = React.lazy(() =>
  import("../../components/EnquiryFormDetailPage/EnquiryFormDetailPage")
);

const BookVisitSiteModal = React.lazy(() =>
  import("../../components/BookVisitSiteModal/BookVisitSiteModal")
);

const DetailPageDetails = (props) => {
  const {
    product,
    cartActionContent,
    discountPrice,
    regularPrice,
    optionSelections,
    availableOptions,
    handleSelectionChange,
    setQuantity,
    quantity,
    reviewData,
    ConfigData,
    handleShowReviewModal,
    buyNowActionContent,
    notifyMe,
    selectedBundle,
    setSelectedBundle,
    configProductVariantId,
    isOutOfStock,
    selectedOptionsArray,
    productDetails,
    vritualProductData,
    pincodeDataFromModal,
  } = props;

  const talonProps = useDetailPageDetails({ product, configProductVariantId });

  const {
    share_url,
    addToCompare,
    isSignedIn,
    isInCompare,
    showBookVisitSite,
    setShowBookVisitSite,
  } = talonProps;

  const options =
    product.__typename === "ConfigurableProduct" ? (
      <>
        <Suspense fallback={<ProductOptionsShimmer />}>
          <hr />
          <Options
            optionSelections={optionSelections}
            availableOptions={availableOptions}
            onSelectionChange={handleSelectionChange}
            options={product.configurable_options}
          />
          <hr />
        </Suspense>
      </>
    ) : null;

  return (
    <>
      <div className={classes.productdetailBox}>
        <div className={classes.share_bestproduct}>
          <h1 className={classes.productname}>{productDetails.name}</h1>
          {/* <div
            className={classes.bestseller_tag}
            style={{ background: product.flag_color }}
          >
            <CiMedal size={16} />
            {product.flag_text}
          </div> */}
          <div className={classes.shareWrapper}>
            <ShareButton product={product} shareUrl={share_url} />
          </div>
        </div>
        <div className={classes.itemcode}>Item code: {productDetails.sku}</div>
        {productDetails?.unit_text ? (
          <span>Unit : {productDetails?.unit_text}</span>
        ) : null}
        {productDetails?.short_description?.html && (
          <div className={classes.des}>
            <div
              dangerouslySetInnerHTML={{
                __html: productDetails?.short_description?.html,
              }}
            />
          </div>
        )}
        {productDetails.sku !== "9101112.G" && (
          <>
            <div className={classes.reviewsection}>
              <div className={classes.reviews_count}>
                {reviewData &&
                  reviewData.products &&
                  reviewData.products.items &&
                  reviewData.products.items &&
                  reviewData.products.items.map((review, idx) => {
                    return (
                      <Fragment key={idx}>
                        <small>
                          {((review.rating_summary / 100) * 5).toFixed(1)}
                        </small>

                        <ul className={classes.rating_outer}>
                          <li
                            className={classes.rating_inner}
                            style={{
                              width: `${review.rating_summary}%`,
                            }}
                          ></li>
                        </ul>
                      </Fragment>
                    );
                  })}
              </div>
              <button type="button" onClick={handleShowReviewModal}>
                {reviewData &&
                reviewData.products &&
                reviewData.products.items &&
                reviewData.products.items[0].review_count >= 1
                  ? "Write a Review"
                  : "Be the first to Review"}
              </button>
            </div>
            <div className={classes.maineprice}>
              {discountPrice && discountPrice.value !== regularPrice.value ? (
                <span>
                  MRP :
                  <label>
                    <FaRupeeSign />
                    {formatIndianNumber(regularPrice.value)}
                  </label>
                </span>
              ) : null}
              {discountPrice ? (
                <>
                  <strong>
                    <FaRupeeSign />
                    {formatIndianNumber(discountPrice.value)}
                  </strong>
                </>
              ) : regularPrice ? (
                <>
                  <strong>
                    <span className={classes.mrpText}>MRP</span>
                    <FaRupeeSign />
                    {formatIndianNumber(regularPrice.value)}
                  </strong>
                </>
              ) : null}

              {discountPrice && discountPrice.value !== regularPrice.value ? (
                <small>
                  {product.__typename === "BundleProduct"
                    ? `- ${(
                        ((regularPrice.value - discountPrice.value) * 100) /
                        regularPrice.value
                      ).toFixed(2)} % OFF`
                    : `- ${productDetails.price_range.minimum_price.discount.percent_off} % OFF`}
                </small>
              ) : null}

              {/* {productDetails.only_x_left_in_stock != null ? (
                <div className={classes.qutyoffer}>
                  Only {productDetails.only_x_left_in_stock} left
                </div>
              ) : null} */}
            </div>
            {discountPrice?.value || regularPrice?.value ? (
              <small className={classes.inclTaxes}>(Incl. of all taxes)</small>
            ) : null}
            {/*{productDetails.only_x_left_in_stock != null ? (
              <div className={classes.qutyofferMobile}>
                Only {productDetails.only_x_left_in_stock} left
              </div>
            ) : null}{" "}
            */}
            {options}
            {/* For Bundle Product */}
            {product["__typename"] === "BundleProduct" &&
            !product.simplebundle ? (
              <>
                <div
                  style={{
                    color: "#111111",
                    fontSize: "18px",
                    fontWeight: "500",
                    textTransform: "uppercase",
                  }}
                >
                  {product.bundle_option_heading}
                </div>

                <ul
                  style={{
                    listStyle: "none",
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    gap: "10px",
                    padding: "10px 0px",
                  }}
                  className={classes.bundleOptionList}
                >
                  {product.items.map((option, index) => (
                    <li key={index}>
                      <button
                        className={classNames(classes.bundleOptionBtn, {
                          [classes.bundleOptionSelected]:
                            option.option_id === selectedBundle,
                        })}
                        onClick={() => setSelectedBundle(option.option_id)}
                      >
                        {option.title}
                      </button>
                    </li>
                  ))}
                </ul>
              </>
            ) : null}
            {selectedBundle ? (
              <>
                <p
                  style={{
                    margin: "0",
                    padding: "0",
                    marginBottom: "12px",
                    fontSize: "20px",
                    fontWeight: "500",
                  }}
                >
                  This includes
                </p>
                <ul
                  style={{
                    listStyleType: "none",
                    marginLeft: "0px",
                    paddingLeft: "6px",
                  }}
                >
                  {[
                    ...(product.items.find(
                      (item) => item.option_id === selectedBundle
                    )?.options || []),
                  ]
                    .sort((a, b) => a.position - b.position)
                    .map((item, idx) => (
                      <li key={idx}>{item.product.name}</li>
                    ))}
                </ul>
              </>
            ) : null}
          </>
        )}
        {productDetails.enable_site_visit !== 1 && (
          <DetailPageCouponModal productSku={productDetails.sku} />
        )}
        {productDetails?.product_highlights && (
          <div className={classes.des}>
            <div
              dangerouslySetInnerHTML={{
                __html: productDetails?.product_highlights,
              }}
            />
          </div>
        )}
        {!productDetails.enable_appliance_site_visit ? (
          <DetailPagePincodeCheck
            product={productDetails}
            ConfigData={ConfigData}
            pincodeDataFromModal={pincodeDataFromModal}
          />
        ) : null}
        <div className="product-type-data">
          {productDetails.enable_site_visit === 1 &&
          !productDetails.enable_appliance_site_visit ? (
            <>
              <div className="price-box">
                <span className="regular-price" id={productDetails.id}>
                  <span className="price">
                    <FaRupeeSign />
                    <strong>
                      {
                        vritualProductData?.products.items[0]?.price_range
                          ?.minimum_price?.final_price?.value
                      }
                    </strong>
                  </span>
                </span>
              </div>

              <div className="redeemable">
                <p className="availability ">
                  <span>
                    (Pre-delivery inspection charges: Adjusted at the time of
                    final purchase -Rs.
                    {
                      vritualProductData?.products.items[0]?.price_range
                        ?.minimum_price?.final_price?.value
                    }
                    )
                  </span>
                </p>
              </div>
            </>
          ) : null}
          {/* <BookVisitSiteModal
            show={showBookVisitSite}
            setShowBookVisitSite={setShowBookVisitSite}
            ConfigData={ConfigData}
            productName={productDetails.name}
          /> */}
          <EnquiryFormDetailPage
            show={showBookVisitSite}
            setShowBookVisitSite={setShowBookVisitSite}
            ConfigData={ConfigData}
            productName={productDetails.name}
          />
          {productDetails.enable_site_visit === 1 ||
          productDetails.enable_appliance_site_visit ? (
            <button
              className={classes.bookVisitSiteBtn}
              onClick={() => setShowBookVisitSite(true)}
            >
              {/* {productDetails.enable_appliance_site_visit
                ? "Request a Free Delivery Inspection"
                : "Enquire Now"} */}
              Enquire Now
            </button>
          ) : null}
          {productDetails.enable_site_visit === 1 &&
          !productDetails.enable_appliance_site_visit ? (
            <>
              {product?.pdf_url && (
                <div className={classes.mypdf}>
                  <Link
                    target="_blank"
                    to={product.pdf_url}
                    style={{ cursor: "pointer" }}
                  >
                    Click to Download Installation Manual
                  </Link>
                </div>
              )}
            </>
          ) : null}
        </div>
        {!productDetails.enable_appliance_site_visit && (
          <div className={classes.quantitybox}>
            <h2>Quantity</h2>
            <div className="row">
              <div className="col-md-4">
                <ProductQuantity
                  setQuantity={setQuantity}
                  quantity={quantity}
                />
              </div>
              <div className="col-md-8">
                <div className="row d-flex align-items-center">
                  <div className="col-md-6">
                    <div className={classes.addtocart}>{cartActionContent}</div>
                  </div>
                  <div className="col-md-6">
                    <div className={classes.buynow}>{buyNowActionContent}</div>
                  </div>
                </div>
              </div>
              <div className="col-md-12">{notifyMe}</div>
            </div>
          </div>
        )}
        <div className={classes.wishlistcompare}>
          <ul>
            <li className={classes.wishlistWrapper}>
              <GetWishlist
                item={product}
                itemId={product.id}
                text={true}
                btnClass={classes.wishlistBtn}
                selectedOptionsArray={selectedOptionsArray}
              />
            </li>
            {}
            {(product["__typename"] === "BundleProduct" &&
              product.simplebundle) ||
            product["__typename"] === "ConfigurableProduct" ||
            (product["__typename"] === "SimpleProduct" && !isOutOfStock) ? (
              <li>
                <a>
                  <button
                    onClick={addToCompare}
                    className={classNames(classes.defaultCompare, {
                      [classes.inCompare]: isInCompare,
                    })}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="1em"
                      height="1em"
                      viewBox="0 0 2048 2048"
                    >
                      <path
                        fill="currentColor"
                        d="M1817 1152h103v128h-22q-20 57-56 104t-85 81t-104 52t-117 19q-60 0-117-18t-105-52t-84-81t-56-105h-22v-128h103l187-560l-418-139v1213q169 11 317 75t272 179h179v128H128v-128h179q123-114 272-178t317-76V410L502 279l163 489h103v128h-22q-20 57-56 104t-85 81t-104 52t-117 19q-60 0-117-18t-105-52t-84-81t-56-105H0V768h103l187-560l-262-87L69 0l827 275V0h128v318l867 288l-41 122l-197-66zM606 896H162q35 60 94 94t128 34q69 0 128-34t94-94m-76-128L384 330L238 768zm430 1024q-118 0-231 32t-213 96h888q-99-63-213-95t-231-33m576-1078l-146 438h292zm222 566h-444q35 60 94 94t128 34q69 0 128-34t94-94"
                      ></path>
                    </svg>
                    Add to Compare
                  </button>
                </a>
              </li>
            ) : null}
          </ul>
        </div>
      </div>
    </>
  );
};

export default DetailPageDetails;
